import { render, staticRenderFns } from "./riskInfo.vue?vue&type=template&id=3a5556d8&scoped=true&"
import script from "./riskInfo.vue?vue&type=script&lang=js&"
export * from "./riskInfo.vue?vue&type=script&lang=js&"
import style0 from "./riskInfo.vue?vue&type=style&index=0&id=3a5556d8&prod&lang=css&"
import style1 from "./riskInfo.vue?vue&type=style&index=1&id=3a5556d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5556d8",
  null
  
)

export default component.exports